import { UseQueryOptions } from "react-query";
import { Guide } from "types";
import { ResourceFetchOptions, useResource } from "./useResource";
import { useAutoFetchCollection } from "@/hooks/useAutoFetchCollection";
import { Options } from "@/hooks/useInfiniteCollection";
import { useAccountStore } from "@/stores/accountStore";

/**
 * Same as `useResource` just prefixes the specified path with `/seller/{id}` for the current seller.
 */
export const useSellerResource = (path: string[], params?: any, options?: UseQueryOptions) => {
    const seller = useAccountStore((state) => state.seller);
    return useResource(["sellers", seller, ...path], params, { enabled: !!seller, ...options });
};

export const useGuides = (params: any = null, options?: Options<Guide>) => {
    const sellerId = useAccountStore((state) => state.seller) ?? "_DEBUG_";
    const query = useAutoFetchCollection<Guide>(["sellers", sellerId, "guides"], params, options);

    return { ...query, guides: query.data, isLoadingGuides: query.isLoading };
};

export const useGuide = (id: string, params: any = null, options?: ResourceFetchOptions<Guide>) => {
    const response = useResource<Guide>(["guides", id], params, options);
    return { ...response, guide: response.data, isLoadingGuide: response.isLoading };
};
